export enum E_PAYMENT_METHOD {
  CASH = "CASH",
  TRANSFER = "TRANSFER",
}

export const PaymentMethodLabels: Record<E_PAYMENT_METHOD, string> = {
  [E_PAYMENT_METHOD.CASH]: "ชำระเงินสด",
  [E_PAYMENT_METHOD.TRANSFER]: "โอน / ชำระผ่านบัญชีธนาคาร",
};
